module.exports = __webpack_public_path__ + "img/appointment-daily.6581c86d.png";